import { Checkbox, MantineSpacing, Stack } from '@mantine/core';
import { ReactElement } from 'react';

interface Props {
  data: { label: ReactElement; value: string }[];
  value: string[];
  onChange: (value: string[]) => void;
  label?: string;
  spacing?: MantineSpacing;
}

export const CheckboxGroup = ({ data, value, onChange, label, spacing = 'sm' }: Props) => {
  return (
    <Checkbox.Group value={value} onChange={onChange} label={label}>
      <Stack mt={spacing}>
        {data.map((radio, index) => (
          <Checkbox key={index} value={radio.value} label={radio.label} />
        ))}
      </Stack>
    </Checkbox.Group>
  );
};
